import DeviceStatuses from './DeviceStatuses';
import React from 'react';
import { waterLeakageStatus } from '../features/Devices/constants/constants';

const DeviceValues = ({ device, style }) => {
  return (
    <>
      {device?.type?.key === 'counter' && <p className={style}>{device?.last_event?.value ? device?.last_event?.value + ' m³' : ''}</p>}
      {device?.type?.key === 'controller' && <DeviceStatuses device={device} style={'truncate text-gray-800'} icon={false} />}
      {device?.type?.sub_type?.key === 'sensor:water:leakage' && device?.last_event?.value !== undefined && (
        <p className={style}>{waterLeakageStatus[device?.last_event?.value] ?? waterLeakageStatus[0]}</p>
      )}
      {device?.type?.sub_type?.key === 'sensor:temperature' && <p className={style}>{device?.last_event?.value ? device?.last_event?.value + ' °C' : ''} </p>}
    </>
  );
};

export default DeviceValues;
